import { useCallback, useEffect, useMemo, useState } from "react";
import { Divider } from "@fluentui/react-components";
import { Label, RadioButton, TextStyle, Button } from "@lannister/duplo";

import { ReactComponent as CardIcon } from "../../assets/icons/card.svg";
import { ReactComponent as EmptyWallet } from "../../assets/icons/empty-wallet.svg";
import { ReactComponent as PCILogo } from "../../assets/images/PCI-Logo.svg";
import { ReactComponent as SahlLogo } from "../../assets/images/Sahl-Logo.svg";
import { ReactComponent as ApplePay } from "../../assets/images/ApplePay.svg";

import { PaymentMethodType } from '../../common/constans';
import Wallet from './wallet';
import CardDetailsForm from './cardDetailsForm';
import ApplePayButton from "../../Components/partials/apple-pay-btn/applePayButton";

const PaymentMethods = ({
    isCardEnabled,
    isWalletEnabled,
    isApplePayEnabled,
    handleChange,
    onSubmit,
    isLoading,
    onChangeSelectedPaymentMethod,
    isFormValid,
    amount,
    currency,
    shouldShowAmount,
    isSaveCardOptionEnabled }) => {

    const [selectedPaymentMethod, setSelectedPaymentMethod] = useState(null)

    const onChangePaymentMethod = useCallback((value) => {
        const selectedMethod = Number(value);
        setSelectedPaymentMethod(selectedMethod)
        onChangeSelectedPaymentMethod(selectedMethod)
    }, [setSelectedPaymentMethod, onChangeSelectedPaymentMethod])
    
    useEffect(()=> {
        const selectedMethod = isApplePayEnabled ? PaymentMethodType.ApplePay : PaymentMethodType.BankCard
        setSelectedPaymentMethod(selectedMethod)
        onChangePaymentMethod(selectedMethod)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const options = useMemo(() => {
        const opts = [];
        if (isApplePayEnabled) {
            opts.push({
                label: "Apple Pay",
                value: PaymentMethodType.ApplePay,
                icon: <ApplePay />
            });
        }

        if (isCardEnabled) {
            opts.push({
                label: "Debit or Credit Card",
                value: PaymentMethodType.BankCard,
                icon: <CardIcon />,
                content: () => <CardDetailsForm handleChange={handleChange} isSaveCardOptionEnabled={isSaveCardOptionEnabled} />
            });
        }
        if (isWalletEnabled) {
            opts.push({
                label: "Digital Wallet",
                value: PaymentMethodType.Wallet,
                icon: <EmptyWallet />,
                content: () => <Wallet handleChange={handleChange} />
            });
        }
        return opts;
    }, [isCardEnabled, isWalletEnabled, isApplePayEnabled, handleChange, isSaveCardOptionEnabled]);

    return (
        <div> 
            <div style={styles.card}>
                <Label labelText="Choose your payment method" textStyle={TextStyle.Heading5Semibold} />
                <RadioButton
                    options={options}
                    defaultValue={isApplePayEnabled ? PaymentMethodType.ApplePay :PaymentMethodType.BankCard}
                    onChange={onChangePaymentMethod}
                />
            </div>

            <div style={{ display: "grid", padding: "12px 0" }}>
                {
                    selectedPaymentMethod === PaymentMethodType.ApplePay ?
                        <ApplePayButton onClick={onSubmit} disabled={!isFormValid || isLoading} /> :
                        <Button onClick={onSubmit} isLoading={isLoading} disabled={!isFormValid}>
                            Pay{shouldShowAmount ? ` ${amount} ${currency}` : ''}
                        </Button>
                }

                
            </div>

           <div style={styles.row}>
                <div style={styles.sahl}>
                    <Label labelText="Powered by" textStyle={TextStyle.BaseRegular} />
                    <SahlLogo />
                </div>
                <div style={{ maxWidth: "fitContent" }}>
                    <Divider vertical />
                </div>
                <PCILogo />
            </div>
        </div>
    );
}

const styles = {
  card: {
    display: "flex",
    flexDirection: "column",
    gap: "12px",
    padding: "24px",
    borderRadius: "16px",
    border: "1px solid #E6E8FA",
    backgroundColor: "#FFFFFF",
    
    alignSelf: "stretch",
  },
  row: {
    display: "flex",
    padding: "12px 0 0 0",
    justifyContent: "center",
    alignItems: "center",
    gap: "32px",
    alignSelf: "stretch",
  },
  sahl: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    alignContent: "center",
    gap: "8px",
    flexWrap: "wrap",
  }
};

export default PaymentMethods;
